import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button } from 'reactstrap';

import { createMapping, fetchSourceTableColumns, fetchTargetColumns } from '../../../../../actions/synchronisationActions';
import { SelectField, RHFField } from '../../../../../components/Field';

const tableOptions = (options) => (options ? options.map((o) => ({ key: o, id: o, name: o })) : []);
const columnOptions = (options) => (options ? options.map((o) => ({ key: o.name, id: o.name, name: o.name })) : []);

// Migrated from redux-form to react-hook-form. Table-change side-effects (fetch
// columns + enable the dependent column) now run off watch() instead of the
// redux-form Field onChange interceptor. withRouter was unused -> dropped.
export const MappingForm = ({ storeId, sourceId, onSelectionChange }) => {
  const dispatch = useDispatch();
  const sourceTables = useSelector((s) => s.sync.sourceTable.tables);
  const sourceColumns = useSelector((s) => s.sync.sourceColumn.columns);
  const targetTables = useSelector((s) => s.sync.targetTable.tables);
  const targetColumns = useSelector((s) => s.sync.targetColumn.columns);
  const resetFlag = useSelector((s) => s.sync.mapping.resetForm);

  const { control, handleSubmit, reset, register, watch } = useForm({ defaultValues: {} });
  const [disableTargetColumn, setDisableTargetColumn] = useState(true);
  const [disableSourceColumn, setDisableSourceColumn] = useState(true);

  const sourceTable = watch('sourceTable');
  const targetTable = watch('targetTable');

  useEffect(() => {
    if (sourceTable && sourceTable.value) {
      dispatch(fetchSourceTableColumns(storeId, sourceTable.value));
      setDisableTargetColumn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceTable]);

  useEffect(() => {
    if (targetTable && targetTable.value) {
      dispatch(fetchTargetColumns(storeId, targetTable.value));
      setDisableSourceColumn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetTable]);

  // Report the current source/target selection up so MappingTable can filter the
  // existing-mappings list (this used to come from redux-form's state.form.mappingForm).
  // reset() clears these, so the watch fires with undefined and we report nulls.
  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange({
        sourceTable: sourceTable && sourceTable.value ? sourceTable.value : null,
        targetTable: targetTable && targetTable.value ? targetTable.value : null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceTable, targetTable]);

  useEffect(() => {
    if (resetFlag) {
      setDisableTargetColumn(true);
      setDisableSourceColumn(true);
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFlag]);

  const resetForm = () => {
    setDisableTargetColumn(true);
    setDisableSourceColumn(true);
    reset();
  };

  const onSubmit = (values) => {
    if (storeId) {
      dispatch(
        createMapping(storeId, sourceId, {
          ...values,
          sourceTable: values.sourceTable && values.sourceTable.value,
          sourceColumn: values.sourceColumn && values.sourceColumn.value,
          targetTable: values.targetTable && values.targetTable.value,
          targetColumn: values.targetColumn && values.targetColumn.value,
        })
      );
    }
  };

  return (
    <tr>
      <td>
        <RHFField name="sourceTable" control={control} component={SelectField} options={tableOptions(sourceTables)} />
      </td>
      <td>
        <RHFField name="sourceColumn" control={control} component={SelectField} options={columnOptions(sourceColumns)} disabled={disableTargetColumn} creatable />
      </td>
      <td>
        <RHFField name="targetTable" control={control} component={SelectField} options={tableOptions(targetTables)} />
      </td>
      <td>
        <RHFField name="targetColumn" control={control} component={SelectField} options={columnOptions(targetColumns)} disabled={disableSourceColumn} />
      </td>
      <td>
        <input {...register('defaultValue')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('rowGroup')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('converter')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td colSpan={2}>
        <div className="d-flex flex-row justify-content-end">
          <Button color="primary" type="submit" onClick={handleSubmit(onSubmit)}>
            Save
          </Button>
          <Button color="secondary" type="button" className="ms-2" onClick={resetForm}>
            Reset
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default MappingForm;
